import { Link } from 'react-router-dom';
import { useTranslation } from '@sib/i18n';
import { Button } from '@sib/ui';
import { InformationWrapper } from '@sib/ui';
import { PageNotFound as PageNotFoundIcon } from '@sib/ui/icons';
import { ABOUTSIB_URL } from '@spendbrain/config/constants';

export const EmptyPagePlaceholder = () => {
  const { t } = useTranslation();

  return (
    <InformationWrapper
      icon={<PageNotFoundIcon className="size-15" />}
      title={t('emptyPagePlaceholder.title')}
      description={t('emptyPagePlaceholder.description')}
      customIconClassName="p-6"
      footer={
        <Button asChild className="h-10">
          <Link target="_blank" to={ABOUTSIB_URL}>
            {t('about')}
          </Link>
        </Button>
      }
    />
  );
};
